import Vue from 'vue'
import Router from 'vue-router'
import {store} from './store.js'
Vue.use(Router)
import Full from '@/components/layout/Full'

//import sessionRouter from '@/views/session/router';
import LoginOne from '@/views/session/LoginOne';
import ForgotPassword from '@/views/session/ForgotPassword';
import ResetPassword from '@/views/session/ResetPassword';
import LoginOneWeb from '@/views/session/LoginOneWeb';

import NotFound from '@/views/notFound/NotFound';

import {
    pushNotificationsRoute
} from '@/views/pushNotification/router';
import {
    pushNotificationsCreateRoute
} from '@/views/pushNotification/router';

import {
    UserListingRoute
} from '@/views/user/router';

import {
    UserCreateRoute
} from '@/views/user/router';


import {
    ImagesRoute
} from '@/views/image/router';

import {
    RequestInspectionRoute
} from '@/views/requestInspection/router';

import {
    QuotingRoute
} from '@/views/quoting/router';

import {
    BonusComplianceRoute
} from '@/views/bonusCompliance/router';

import {
    BonusProductionRoute
} from '@/views/bonusProduction/router';

import {
    BonusCategoryRoute
} from '@/views/bonusCategory/router';


import {
    CommercialRoute
} from '@/views/commercial/router';

import {
    OrderEmisionRoute
} from '@/views/orderEmision/router';

import {
    CommissionRoute
} from '@/views/commission/router';

import {
    ElecttronicDocumentRoute
} from '@/views/electtronicDocument/router';

import {
    ElectronicBillingRoute
} from '@/views/electronicBilling/router';

import {
    ProductionReportRoute
} from '@/views/productionReport/router';

import { 
    LinkFormRoute 
} from '@/views/linkForm/router';

import { 
    CarteraRoute 
} from '@/views/cartera/router';
import { 
    ReunionCarteraRoute 
} from '@/views/reunionCartera/router';
import { EcommerceRoute } from './views/ecommerce/router.js'

import {
    CotizadorRoute
} from '@/views/cotizador/router';

let redirectValue = '/images';
if(store.getters.userScopes){
    if(store.getters.userScopes.includes('aps_broker')){
        redirectValue = '/commission/commissionList'
    }
}

const router = {
    path: '/',
    component: Full,
    redirect: redirectValue,
    children: [
        pushNotificationsRoute,
        pushNotificationsCreateRoute,
        UserListingRoute,
        UserCreateRoute,
        ImagesRoute,
        RequestInspectionRoute,
        QuotingRoute,

        BonusProductionRoute,
        BonusComplianceRoute,
        BonusCategoryRoute,
        CommercialRoute,
        OrderEmisionRoute,
        CommissionRoute,
        ElecttronicDocumentRoute,
        ElectronicBillingRoute,
        ProductionReportRoute,
        LinkFormRoute,
        CarteraRoute,
        ReunionCarteraRoute,
        EcommerceRoute,
        CotizadorRoute
    ]
}

export default new Router({
    mode: 'history', 
    routes: [
        router,
        {
            path: '/404',
            component: NotFound
        },
        {
            path: '*',
            redirect: '/404'
        },
        {
            path: '/session/login',
            component: LoginOne,
            meta: {
                title: 'message.login',
                breadcrumb: 'Session / Login'
            }
        },
        {
            path: '/session/web/login/:token/:rtoken/:etime/:eRtime',
            props: {
                token: true
            },
            component: LoginOneWeb,
        },
        {
            path: '/session/forgot-password',
            component: ForgotPassword,
            meta: {
                title: 'Forgot Passwprd',
                breadcrumb: 'Session / Forgot Password'
            }
        },
        {
            path: '/session/reset-password',
            component: ResetPassword,
            meta: {
                title: 'Reset Password',
                breadcrumb: 'Session / Reset Password'
            }
        }
    ]
})